<template>
  <div class="content">
    <div class="condition">
      <div class="search_wrap">
        <el-form :inline="true" :model="form" class="form-inline">
          <el-form-item label="输入核销码：">
            <el-input v-model="form.code" size="small"></el-input>
          </el-form-item>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
           <el-form-item label="输入核销人：">
            <el-input v-model="form.verification" size="small"></el-input>
          </el-form-item>         
          <el-form-item>
            <el-button type="primary" @click="onSubmit" size="small">确定</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table_wrap mt20">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="name" label="姓名"></el-table-column>
          <el-table-column prop="verification_time" label="核销时间"></el-table-column>
          <el-table-column prop="cash" label="代金券面额/元"></el-table-column>
          <el-table-column prop="code" label="核销码"></el-table-column>
          <el-table-column prop="verification" label="核销人"></el-table-column>
        </el-table>  
      </div>
      <div class="pag_wrap">
        <el-pagination
                background
                @current-change="pageIndexChange"
                :page-size="page.pagesize"
                :current-page="page.pageindex"
                layout="total, prev, pager, next"
                :total="page.total"
        ></el-pagination>
      </div>      
    </div>
  </div>
</template>

<script>
import api from "@/api.js";
import {pagination} from "@/util/util.js";
export default {
  name: "writeOffVoucher",
  data() {
    return {
      form: {
        code: "",
        verification: ""
      },
      tableData: [],
      page: {
        pageindex: pagination.pageIndex,
        pagesize: pagination.pageSize,
        total: pagination.total
      }
    }
  },
  created() {
    this.initFn();
  },
  methods: {
    initFn() {
      this.axios
        .post(api.coupon_verificationList, {page:this.page.pageindex})
        .then(response => {
          if (response.data.code == 0) {
            this.tableData = response.data.list
            this.page.total = response.data.all_page
          } 
        })
        .catch(response => {
        });
    },
    pageIndexChange(pageindex) {
      this.page.pageindex = pageindex;
      this.initFn();
    },
    onSubmit() {
      this.axios
        .post(api.coupon_verification, this.form)
        .then(response => {
          if (response.data.code == 0) {
            this.$message.success(response.data.msg);
            this.initFn();
          }
        })
        .catch(response => {
        });
    }
  }
}
</script>